// @core/api/endpoints/authn/delete_oauth2_client.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/authn';

/**
 * Delete OAuth2 client
 * Permanently removes an OAuth2 client and revokes all associated tokens and grants. This action cannot be undone.
 */
export async function DeleteOAuth2Client(
  client_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/clients/:client_id`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
